// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__tB3Nc","footer":"ModalCreateQualiphyProcedure_footer__3QHz-","additionData":"ModalCreateQualiphyProcedure_additionData__2PMa7"};